import { render, staticRenderFns } from "./MentoringPage.vue?vue&type=template&id=518d4332&scoped=true&"
import script from "./MentoringPage.vue?vue&type=script&lang=js&"
export * from "./MentoringPage.vue?vue&type=script&lang=js&"
import style0 from "./MentoringPage.vue?vue&type=style&index=0&id=518d4332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d4332",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
